webpackJsonp([136952960639044],{

/***/ 2003:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ScheduleTemplateRange","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"appointmentType","type":{"kind":"OBJECT","name":"AppointmentType","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"appointmentTypeId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"range","type":{"kind":"SCALAR","name":"Numrange","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-schedule-template-range-4e962a9b7ffddb46647a.js